import { ClassValue, cn } from "@networx/utils/tailwind/cn";
import type { Dictionary } from "@networx/utils/types/Dictionary";
import type { Falsy } from "@networx/utils/types/Falsy";

import "@total-typescript/ts-reset/filter-boolean";

/**
 * Merge dictionaries of classes.
 * ```typescript
 * props.classNames = mergeClassNames([
 * 	// default classNames
 * 	{
 * 		container: "flex",
 * 		inner: "p-0"
 * 	},
 * 	// incoming classNames
 * 	props.classNames,
 * ]);
 * ```
 */
export function mergeClassNames<S extends SlotsToClasses>(classNamesObjects: (S | Falsy)[]) {
  return classNamesObjects.reduce((result: Dictionary<string>, classNames) => {
    if (classNames)
      Object.entries(classNames).forEach(([name, classes]) => (result[name] = cn(result[name], classes)));

    return result;
  }, {});
}

type SlotsToClasses<S extends string = string> = {
  [key in S]?: ClassValue;
};
